import { useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { Panel, Btn, RT } from "./ui";
import { Sparkles, Loader2 } from "lucide-react";

const GROUPS = [["grammar_spelling", "GRAMMAR & SPELLING"], ["chronology_issues", "CHRONOLOGY"],
  ["missing_fields", "MISSING FIELDS"], ["neutral_language_suggestions", "NEUTRAL LANGUAGE"],
  ["inconsistency_alerts", "INCONSISTENCY ALERTS"]];

// Whole-report AI QC — suggestions only, never modifies the report (Add-on 19).
export default function AiReviewPanel({ rep }) {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const res = await client.post(`/rms-reports/${rep.id}/ai-review`); setR(res.data.review); }
    catch (e) { toast.error(e.response?.data?.detail || "AI review failed"); }
    setBusy(false);
  };
  return (
    <Panel title="AI Report Review — QC Suggestions" testid="ai-review-panel">
      <div className="font-mono text-[10px] mb-2" style={{ color: RT.dim }}>
        Checks grammar, chronology, missing fields, neutral language and inconsistencies.
        The AI never invents or changes facts, never removes exculpatory information, never draws legal
        conclusions, and never replaces your certification — it only suggests; you decide.
      </div>
      <Btn onClick={run} disabled={busy} testid="ai-review-run">
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />} Run AI Review
      </Btn>
      {r && (
        <div className="mt-2 border rounded-sm p-2" style={{ borderColor: "#a855f7" }} data-testid="ai-review-results">
          <div className="font-mono text-[9px] font-bold mb-1.5" style={{ color: "#7e22ce" }}>{r.label}</div>
          {GROUPS.map(([k, label]) => (r[k] || []).length > 0 && (
            <div key={k} className="mb-1.5">
              <div className="font-mono text-[9px] font-bold uppercase" style={{ color: RT.dim }}>{label} ({r[k].length})</div>
              {r[k].map((s, i) => <div key={i} className="font-mono text-[10px] py-0.5" style={{ color: RT.text }}>• {s}</div>)}
            </div>))}
          {GROUPS.every(([k]) => !(r[k] || []).length) && <div className="font-mono text-[10px]" style={{ color: "#15803d" }}>No issues found.</div>}
        </div>)}
    </Panel>
  );
}
